import { render, staticRenderFns } from "./RegisterAcknowledge.vue?vue&type=template&id=02772e98&"
import script from "./RegisterAcknowledge.vue?vue&type=script&lang=js&"
export * from "./RegisterAcknowledge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports